<div class="container-fluid px-0" style="background-image: url('assets/images/Vector.png'); min-height: 100vh;background-color: rgba(35, 113, 211, 0.03);">
    <div class="heading-top bg-white d-flex">
        <div class="h6 font-weight-bold pt-1 sm-22">
           <i class="fas fa-university px-2 primary-text"></i>
            Payment methods
        </div>
    </div>

    <div  class="col-sm-10 mt-2 p-0 pt-2 ml-md-5">

        <form *ngIf="!bankShown" class="w-100 m-0 d-flex flex-wrap justify-content-around">

            <div class="form-group py-3 text-center col-12 col-md-5">
                <p class="sm-16 pt-3 color-gray text-left font-weight-bold d-flex justify-content-between m-1">
                    List of Banks
                    <button (click)="onAddBank()" class="outline-none bg-transparent border border-dark rounded cursor-pointer" data-toggle="tooltip" title="Add Bank">
                        <i class="fas fa-plus"></i>
                    </button>
                </p>
                <!-- <div class="w-100 bg-white my-2 p-2 text-left rounded box-shadows">
                    State Bank of India <br />
                    Bhopal<br />
                    India
                </div> -->
                <!-- THE WHOLE COMMENTED PART INSIDE FOR EACH LOOP -->
                <div class="w-100 bg-white my-2 p-2 text-left rounded box-shadows" *ngFor="let item of bankMethods">
                    {{item.account_holder_name}} <br>
                    {{item.institution_name}} <br>
                    {{item.funding_source_name}}<br>
                    {{item.account_type}}
                </div>
            </div>
            <div class="form-group py-3 text-center col-12 col-md-5">
                <p class="sm-16 pt-3 color-gray text-left font-weight-bold d-flex justify-content-between m-1">
                    List of cards
                    <button (click)= "onAddCard()" class="outline-none bg-transparent border border-dark rounded cursor-pointer" data-toggle="tooltip" title="Add Card">
                        <i class="fas fa-plus"></i>
                    </button>
                </p>
                <div class="w-100 bg-white my-2 p-2 text-left rounded box-shadows" *ngFor="let item of cardMethods">
                    {{item.account_holder_name}} <br>
                    {{item.institution_name}} <br>
                    {{item.funding_source_name}}<br>
                    {{item.account_type}}
                </div>
            </div>
            
            
            
        </form>
        <button *ngIf="bankShown" (click)="bankShown=false" class="cursor-pointer btn primary-btn px-5 ml-3">Close</button>
        <div class="p-3" [ngClass]="{'d-none': !bankShown}" id="widget-root-type"></div>

    </div>
    <!-- <div class="p-0" [ngClass]="{'d-none': !bankShown}" id="widget-root-type"></div> -->
</div>